(function () {
    'use strict';

    angular
        .module('translateModule', ['JB.translate.srv'])
        .run(['$rootScope', 'Translate', jbTranslate]);

    function jbTranslate($rootScope, Translate) {
        if (!$rootScope.translate) {
            Translate.buildDirectory();
        }
    }

})();



// WEBPACK FOOTER //
// ./app/controllers/translateController.js